import React from 'react';
import { useDispatch } from 'react-redux';
import i18n from 'i18n';
import { StubLoginToProceed } from 'components/StubLoginToProceed';
import { PurchasesIcon } from './StyledComponents';
import { navigateToAuthPage } from 'actions/app';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';

const NotLoggedStub = () => {
  const dispatch = useDispatch();
  const onLoginEnter = () => {
    innerAnalyticsVolia.postEvent({
      eventGroup: 'dashboard: PURCHASES',
      eventName: 'click sign in',
    });

    dispatch(navigateToAuthPage());
  };

  return (
    <StubLoginToProceed onLoginEnter={onLoginEnter}>
      <PurchasesIcon />
      <div>{i18n.t('purchases.loginToProceed')}</div>
    </StubLoginToProceed>
  );
};

export default NotLoggedStub;
